// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"657a4ded","453":"1407b060","629":"cfccfc63","678":"f49efd2c"}[chunkId] + ".chunk.js";
};